"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_UPDATE_CONFIG_DOC_ID = void 0;
/** Document ID for the singleton app update config */
exports.APP_UPDATE_CONFIG_DOC_ID = 'app-config';
//# sourceMappingURL=AppUpdate.js.map